import { post, get } from "@/utils/utils";
// 导购相关接口
const portraitLabelMgt = {
    state: {
        tagAttributeList: []
    },
    mutations: {
        QUERY_VIEW_TIMES() {},
        QUERY_TRACK_LIST() {},
        QUERY_LOOP_STATUS() {},
        QUERY_TAG_LIST() {},
        UPDATE_TAG_ENABLE_STATE() {},
        QUERY_TAG_ATTRIBUTE(state, data) {
            const { result } = data;
            state.tagAttributeList = result;
        },
        QUERY_TAG_ATTR_LIST() {},
        QUERY_TAG_DETAILS() {},
        QUERY_TAG_CATEGORY_LIST() {},
        QUERY_NEXT_LEVEL_TAG_CAT() {},
        ADD_TAG_CATEGORY() {},
        EDIT_TAG_CATEGORY() {},
        REMOVE_TAG_CATEGORY() {},
        QUERY_ALL_TAG_CAT() {},
        CREATE_TAG() {},
        QUERY_TAG_CAT_DETAILS() {},
        QUERY_TABLE_STRUCTURE() {},
        REMOVE_TAG() {},
        EDIT_TAG() {},
        TAG_COPY(){},
        AUDIT_TAG() {},
        QUERY_PORTRAIT_LIST() {},
        QUERY_PORTRAIT_DETAILS() {},
        QUERY_TAG_RUN_DETAILS() {},
        QUERY_DATASOURCE() {},
        QUERY_LABEL_STORE_CODE() {},
        QUERY_TAG_INCLUDE_RESULT_LIST() {},
        QUERY_TAG_MONITOR() {},
        QUERY_LOOP_LABEL() {},
        QUERY_TAG_WARN_LIST() {},
        QUERY_TAG_INVALIDS() {},
        QUERY_PORTRAIT_DETAILS_BY_USER() {},
        QUERY_PORTRAIT_DETAILS_BY_GOODS() {},
        QUERY_TAG_ATTR_TEST() {},
        QUERY_TAG_DELETE() {},
        QUERY_TAG_DATALIST() {},
        QUERY_TAG_MAKE() {},
        QUERY_ALL_TAG_RUN() {},
        TAG_GROUP_ADD() {},
        TAG_GROUP_LIST() {},
        TAG_GROUP_ESTIMATE() {},
        TAG_GROUP_DETAIL() {},
    },
    actions: {
        // 标签手动更新
        queryRunCat({ commit }, params) {
            return post({
                commit,
                url: `/tag/run`,
                name: "QUERY_ALL_TAG_RUN",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryPortraitDetailsByUser({ commit }, params) {
            return post({
                commit,
                url: `/tag/portrait/user`,
                name: "QUERY_PORTRAIT_DETAILS_BY_USER",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryPortraitDetailsByGoods({ commit }, params) {
            return post({
                commit,
                url: `/tag/portrait/good`,
                name: "QUERY_PORTRAIT_DETAILS_BY_GOODS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagInvalids({ commit }, params) {
            return post({
                commit,
                url: `/tag/invalids`,
                name: "QUERY_TAG_INVALIDS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagWarnList({ commit }, params) {
            return post({
                commit,
                url: `/tag/warns`,
                name: "QUERY_TAG_WARN_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagMonitor({ commit }, params) {
            return get({
                commit,
                url: `/tag/monitor`,
                name: "QUERY_TAG_MONITOR",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagIncludeResultList({ commit }, params) {
            return post({
                commit,
                url: `/tag/records`,
                name: "QUERY_TAG_INCLUDE_RESULT_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagDelete({ commit }, params) {
            return post({
                commit,
                url: `/tag/records/delete`,
                name: "QUERY_TAG_DELETE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryDataSource({ commit }, params) {
            return post({
                commit,
                url: `/tag/dataSource`,
                name: "QUERY_DATASOURCE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryLabelStoreCode({ commit }, params) {
            return get({
                commit,
                url: `/tag/cat/stores`,
                name: "QUERY_LABEL_STORE_CODE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagMake({ commit }, params) {
            return post({
                commit,
                url: `/tag/records/delete/mark`,
                name: "QUERY_TAG_MAKE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagDataList({ commit }, params) {
            return get({
                commit,
                url: `/tag/records/delete/list`,
                name: "QUERY_TAG_DATALIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagRunDetails({ commit }, params) {
            return post({
                commit,
                url: `/tag/detail`,
                name: "QUERY_TAG_RUN_DETAILS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        auditTag({ commit }, params) {
            return post({
                commit,
                url: `/tag/edit/audit`,
                name: "AUDIT_TAG",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryPortraitList({ commit }, params) {
            return post({
                commit,
                url: ``,
                name: "QUERY_PORTRAIT_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryPortraitDetails({ commit }, params) {
            return post({
                commit,
                url: ``,
                name: "QUERY_PORTRAIT_DETAILS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagDetails({ commit }, params) {
            return post({
                commit,
                url: `/tag/queryById`,
                name: "QUERY_TAG_DETAILS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTableStructure({ commit }, params) {
            return post({
                commit,
                url: `/tag/sql/all`,
                name: "QUERY_TABLE_STRUCTURE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagCatDetails({ commit }, params) {
            return post({
                commit,
                url: `/tag/cat/queryById`,
                name: "QUERY_TAG_CAT_DETAILS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        createTag({ commit }, params) {
            return post({
                commit,
                url: `/tag/create`,
                name: "CREATE_TAG",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        removeTag({ commit }, params) {
            return post({
                commit,
                url: `/tag/delete`,
                name: "REMOVE_TAG",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        coptTag({ commit }, params) {
            return post({
                commit,
                url: `/tag/tagCopy`,
                name: "TAG_COPY",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        editTag({ commit }, params) {
            return post({
                commit,
                url: `/tag/edit`,
                name: "EDIT_TAG",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        addTagCategory({ commit }, params) {
            return post({
                commit,
                url: `/tag/cat/add`,
                name: "ADD_TAG_CATEGORY",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        removeTagCategory({ commit }, params) {
            return post({
                commit,
                url: `/tag/cat/delete`,
                name: "REMOVE_TAG_CATEGORY",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        editTagCategory({ commit }, params) {
            return post({
                commit,
                url: `/tag/cat/edit`,
                name: "EDIT_TAG_CATEGORY",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryNextLevelTagCat({ commit }, params) {
            return get({
                commit,
                url: `/tag/cat/all`,
                name: "QUERY_NEXT_LEVEL_TAG_CAT",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryAllTagCat({ commit }, params) {
            return get({
                commit,
                url: `/tag/cat/all`,
                name: "QUERY_ALL_TAG_CAT",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagCategoryList({ commit }, params) {
            return get({
                commit,
                url: `/tag/cat/page`,
                name: "QUERY_TAG_CATEGORY_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagAttrList({ commit }, params) {
            return get({
                commit,
                url: `/tag/rule/attr/list`,
                name: "QUERY_TAG_ATTR_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagtest({ commit }, params) {
            return post({
                commit,
                url: `/tag/test`,
                name: "QUERY_TAG_ATTR_TEST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        updateTagEnableState({ commit }, params) {
            return post({
                commit,
                url: `/tag/edit/enabled`,
                name: "UPDATE_TAG_ENABLE_STATE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagAttribute({ commit }, params) {
            return get({
                commit,
                url: `/tag/cat/all`,
                name: "QUERY_TAG_ATTRIBUTE",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTagList({ commit }, params) {
            return get({
                commit,
                url: `/tag/list`,
                name: "QUERY_TAG_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryViewTimes({ commit }, params) {
            return get({
                commit,
                url: `/event/attr/category/detail`,
                name: "QUERY_TRACK_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryTrackList({ commit }, params) {
            return get({
                commit,
                url: `/event/attr/category`,
                name: "QUERY_TRACK_LIST",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryLoopStatus({ commit }, params) {
            return get({
                commit,
                url: `/event/attr/queryById`,
                name: "QUERY_LOOP_STATUS",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        queryLoopLabel({ commit }, params) {
            return get({
                commit,
                url: `/tag/monitor/statistics`,
                name: "QUERY_LOOP_LABEL",
                params,
                isQueryString: false,
                useOtherServerAddress: "labelAddress"
            });
        },
        tagGroupAdd({ commit }, params) {
            return post({
                commit,
                url: `/tag/group/add`,
                name: "TAG_GROUP_ADD",
                params,
            });
        },
        tagGroupList({ commit }, params) {
            return post({
                commit,
                url: `/tag/group/list`,
                name: "TAG_GROUP_LIST",
                params,
            });
        },
        tagGroupEstimate({ commit }, params) {
            return post({
                commit,
                url: `/tag/group/estimate`,
                name: "TAG_GROUP_ESTIMATE",
                params,
            });
        },
        tagGroupDetail({ commit }, params) {
            return post({
                commit,
                url: `/tag/group/detail`,
                name: "TAG_GROUP_DETAIL",
                params,
            });
        },
    }
};

export default portraitLabelMgt;